import { combineReducers } from 'redux';
import {
    HighlightLayoutsFetchSuccessActionType,
    HighlightLayoutsFetchRequestActionType,
    HighlightLayoutsFetchFailureActionType,
} from './highlightLayoutAction';
import { ActionType } from 'store/ActionType';
import { MyHighlightLayoutDto } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

const layouts = (
    state: MyHighlightLayoutDto[] = [],
    action: ActionType,
) => {
    switch (action.type) {
        case HighlightLayoutsFetchSuccessActionType:
            {
                return action.payload;
            }
        default: {
            return state;
        }
    }
};

const isLoading = (state = false, action: ActionType) => {
    switch (action.type) {
        case HighlightLayoutsFetchRequestActionType: {
            return true;
        }
        case HighlightLayoutsFetchFailureActionType:
        case HighlightLayoutsFetchSuccessActionType: {
            return false;
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({
    layouts,
    isLoading,
});
